import { Container, Stack } from "@mui/material"
import { Outlet } from "react-router"

import useOffSetTop from "@sap/hooks/useOffSetTop"

import { HEADER } from "../../config"
import Header from "./Header"

export default function CompactLayout({
  children,
  useChildren,
}: {
  children?: JSX.Element
  useChildren?: boolean
}) {
  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP)

  return (
    <>
      <Header isOffset={isOffset} />

      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: "auto",
            maxWidth: 400,
            minHeight: "100vh",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          {useChildren ? children : <Outlet />}
        </Stack>
      </Container>
    </>
  )
}
